import React, { useEffect } from 'react';
import Header from '../../components/header/Header'
import Contact from '../../components/contact/Contact';
import Footer from '../../components/footer/Footer'
import { Container } from '@mui/material'
import SEO from '../../components/SEO/SEO';
import { contactPageSchema } from '../../components/SEO/structuredData';

export default function ContactPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <SEO
        title="Contact Us - ManageEcom | Get Support & Inquiries"
        description="Contact ManageEcom for any inquiries about our multichannel eCommerce management software. Call us at +91-7718895734 or email support@nuvio.in for expert assistance."
        keywords="contact manageecom, ecommerce support, inventory software support, manageecom customer service, ecommerce help india"
        canonical={process.env.REACT_APP_MANAGEECOM_BASE_URL+"/contact"}
        structuredData={contactPageSchema}
      />
      <Header />
      <div className='back-small-div' />

      <Container className="back-small-div-container mb-4">
        <div className='center'>
          <div >
            <h1 className="text-light text-center"><b>CONTACT US</b></h1>
            <h6 className='text-light text-center'>We're open for any suggestion or just to have chat.</h6>
          </div>
        </div>
      </Container>
      <Contact className="mt-20" />
      <Footer />
    </div>
  )
}
